
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import { AutocompleteNombre, CargandoMedio } from "../../components";
import { cantidadColor, cantidax10, cantidax50, corteVinilo, estructurasEcosolvente, litografia, nombreSoloCantidad, prendas } from "../../../data";
import { FormularioCantidadColor, FormularioCantidadx10, FormularioCantidadx50, FormularioCorteVinilo, FormularioEstructuras, FormularioLitografia, FormularioPrendas, FormularioSoloCantidad } from "../formularios";
import { useAuthStore, useGlobalValueStore, useProductosStore } from "../../../stores";
import { useListCarritoXUser, useProductosXCategoria, useProductosXID } from "../../../hooks/cache";
import { agregarItemCarritoAdmin } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";
import { LayoutCrearDoc } from "../../layouts";


const baseUrl = process.env.REACT_APP_API_URL;
const createInitialValues = (prod, usuarioId) => ({
    producto: prod,
    usuario: usuarioId,
    cantidad: '',
    color: '',
    talla: '',
    genero: '',
    disenio: '',
    unidadMedida: '',
    alto: '',
    ancho: '',
    terminados: '',
    totalCliente: '',
    totalDistri: '',
    totalEmpresa: '',
    totalPublicista: '',
});



export const DetalleProducto = () => {


    const { cat, prod } = useParams();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { usuario } = useAuthStore();
    const { view } = useGlobalValueStore();
    const { data, isLoading } = useProductosXCategoria(cat);
    const { setActivarTerminado, activarProductoupdate, setActivarProdUpdate } = useProductosStore();
    const [formCarrito, setFormCarrito] = useState( createInitialValues(prod, usuario.id) );
    const { data:produc } = useProductosXID(formCarrito.producto);
    const { data:carrito } = useListCarritoXUser(usuario.id);
    const titulo = (view) ? `Venta realizada a ${view}` : 'Por favor seleccione tipo de cliente';
    

    const handleInputProducto = (newValor) => {
        setFormCarrito({ ...formCarrito, producto:(newValor) ? newValor.id : null });
    }



    const handleAgregarAlCarro = async( itemExistente=null ) => {
        const validarItem = itemExistente || activarProductoupdate?.id;
        const resp = await agregarItemCarritoAdmin(formCarrito, validarItem);

        if( resp ){ 
            setFormCarrito(createInitialValues(prod, usuario.id));
            await queryClient.invalidateQueries({ queryKey: ['carritoxuser'] });
            setActivarTerminado(null);
        }

        if( activarProductoupdate ){
            return navigate(`/super/comprar-ahora`);
        }
    }



    useEffect(() => {
        if(activarProductoupdate) {
            const { producto, terminados, ...resto } = activarProductoupdate;
            setFormCarrito({ ...formCarrito, terminados: (terminados) ? terminados._id : '', ...resto })
        }
        return () => { setActivarProdUpdate(null) }
    }, [activarProductoupdate]);




    return (

        <LayoutCrearDoc titulo='Detalles de Producto' subtitulo={titulo} add={false}>
            {(produc) 
            ?   <Grid container sx={{mt:5}}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={5}>
                            <img src={ `${baseUrl}/uploads/productos/${ produc?.img }`} style={{width:'100%'}} />
                        </Grid>

                        <Grid item xs={12} sm={7}>
                            <Typography variant="h4" sx={{fontSize:'22px', mt:-1}}>Seven For Ever S.A.S.</Typography>
                            <Typography variant="body">{ produc.nombre }</Typography>

                            <Grid item xs={12} sx={{mt:1}}>
                                <AutocompleteNombre
                                    size="small"
                                    name="producto"
                                    value={ formCarrito.producto }
                                    onChange={ handleInputProducto }
                                    options={isLoading ? [] : data}
                                />
                            </Grid>


                            {(prendas.includes(produc.categoria.nombre)) &&
                            <FormularioPrendas
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ carrito }
                            />
                            }

                            {(nombreSoloCantidad.includes(produc.categoria.nombre)) &&
                            <FormularioSoloCantidad
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ carrito }
                            />
                            }

                            {(cantidadColor.includes(produc.categoria.nombre)) &&
                            <FormularioCantidadColor 
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ carrito }
                            />
                            }

                            {(litografia.includes(produc.categoria.nombre)) &&
                            <FormularioLitografia
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ carrito }
                            />
                            }

                            {(estructurasEcosolvente.includes(produc.categoria.nombre)) &&
                            <FormularioEstructuras 
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ carrito }
                            />
                            }

                            {(cantidax10.includes(produc.categoria.nombre)) &&
                            <FormularioCantidadx10 
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ carrito }
                            />
                            }

                            {(cantidax50.includes(produc.categoria.nombre)) &&
                            <FormularioCantidadx50 
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ carrito }
                            />
                            }

                            {(corteVinilo.includes(produc.categoria.nombre)) &&
                            <FormularioCorteVinilo 
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ carrito }
                            />
                            }
                        </Grid>
                    </Grid>


                    <Grid container sx={{mt:3, display:'flex', flexDirection:'column', mb:2}}>
                        <Typography variant="h2" gutterBottom>Uso del Producto</Typography>
                        <Typography variant="body" sx={{mt:-1}}>{ produc.uso }</Typography>
                    </Grid>


                    <Grid container sx={{mt:3, display:'flex', flexDirection:'column', mb:2}}>
                        <Typography variant="h2" gutterBottom>Recomendaciones</Typography>
                        <Typography variant="body" sx={{mt:-1}}>{ produc.recomendaciones }</Typography>
                    </Grid>

                </Grid>

            :   <CargandoMedio titulo="Cargando Producto..." />

            }
        </LayoutCrearDoc>
    )
}
